/**
 * Cart Rewards + Freebie Guard
 *
 * The free gift is DISPLAY ONLY. It is never added to the Shopify cart, so it
 * cannot reach checkout and cannot be charged for. This script:
 *
 *   1. Strips any `_freebie` line item found in the cart. Earlier builds of this
 *      file auto-added the gift via /cart/add.js at full price with no discount
 *      attached, so live carts may still carry one — those must be removed or
 *      the customer pays for their "free" gift at checkout.
 *   2. Keeps the rewards progress bar and the offer note in sync with the cart
 *      total, since the drawer swaps only the line-items section on qty changes.
 *
 * Thresholds and copy live in Liquid (snippets/rewards-progress-bar.liquid,
 * snippets/freebie-offer-note.liquid). Nothing here needs a variant ID.
 */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';
  var _busy = false;
  var _selfUpdate = false;

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function removeFromCart(key) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0, sections: SECTION })
    }).then(function (r) { if (!r.ok) throw new Error('rm'); return r.json(); });
  }

  // Hide stale gift rows straight away so they don't flash while we remove them.
  function hideFreebies() {
    var els = document.querySelectorAll('[data-freebie]');
    for (var i = 0; i < els.length; i++) els[i].style.display = 'none';
  }

  // Show/hide the display-only gift rows against the qualifying cart total.
  function syncGiftRows(total) {
    var rows = document.querySelectorAll('[data-gift-threshold]');
    for (var i = 0; i < rows.length; i++) {
      rows[i].hidden = total < (parseInt(rows[i].getAttribute('data-gift-threshold'), 10) || 0);
    }
  }

  function paint(total) {
    if (typeof window.updateCartRewards === 'function') window.updateCartRewards(total);
    syncGiftRows(total);
  }

  function patchDrawer(resp) {
    var html = resp && resp.sections && resp.sections[SECTION];
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var oldD = document.querySelector('#CartDrawer');
    var newD = doc.querySelector('#CartDrawer');
    if (!oldD || !newD) return;

    _selfUpdate = true;
    oldD.innerHTML = newD.innerHTML;

    var el = document.querySelector('cart-drawer');
    var nel = doc.querySelector('cart-drawer');
    if (el && nel) {
      var a = el.classList.contains('active');
      var an = el.classList.contains('animate');
      el.className = nel.className;
      if (a) el.classList.add('active');
      if (an) el.classList.add('animate');
    }
    var ov = document.querySelector('#CartDrawer-Overlay');
    if (ov && el) ov.addEventListener('click', function () { el.close(); });

    setTimeout(function () { _selfUpdate = false; }, 100);
  }

  function run() {
    if (_busy) return;
    _busy = true;

    fetchCart().then(function (cart) {
      if (!cart || !cart.items) return;

      var realTotal = 0;
      var stale = [];
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.properties && item.properties._freebie) {
          stale.push(item.key);
        } else {
          realTotal += item.final_line_price;
        }
      }

      paint(realTotal);
      if (!stale.length) return;

      hideFreebies();

      var chain = Promise.resolve();
      var last = null;
      for (var j = 0; j < stale.length; j++) {
        (function (key) {
          chain = chain
            .then(function () { return removeFromCart(key); })
            .then(function (r) { last = r; });
        })(stale[j]);
      }

      return chain.then(function () {
        if (last) {
          patchDrawer(last);
          paint(realTotal);
        }
      });
    })
    .catch(function (e) { console.error('[Freebie]', e); })
    .then(function () { _busy = false; });
  }

  // Trigger 1: Page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 80); });
  } else {
    setTimeout(run, 80);
  }

  // Trigger 2: Cart drawer content changes (add-to-cart, qty change, remove)
  var _debounce = null;
  function onDrawerChange() {
    if (_selfUpdate) return;
    clearTimeout(_debounce);
    _debounce = setTimeout(run, 300);
  }

  var drawer = document.getElementById('CartDrawer');
  if (drawer) {
    new MutationObserver(onDrawerChange).observe(drawer, { childList: true, subtree: true });
  }

  window.manageCartFreebie = run;
})();
